module.exports = __webpack_public_path__ + "img/noticia-17.6801c1ac.jpg";